import script from "./Styles.vue?vue&type=script&setup=true&lang=js"
export * from "./Styles.vue?vue&type=script&setup=true&lang=js"

import "./Styles.vue?vue&type=style&index=0&id=ab73ea84&lang=scss"

const __exports__ = script;

export default __exports__